import { type AxiosRequestConfig } from 'axios'

const restorePassword = (
  newPassword: string,
  token?: string,
): AxiosRequestConfig => {
  return {
    method: 'POST',
    url: '/auth/restore-password',
    headers: {
      'Password-Reset-Token': token,
    },
    data: {
      newPassword,
    },
  }
}

export { restorePassword }
